import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { formatMoney } from "../../../utils/helpers";

const Footer = ({ checkout }) => {
  const { t } = useTranslation(["checkout"]);

  const subtotalAmount = checkout?.cost?.subtotalAmount;
  const totalAmount = checkout?.cost?.totalAmount;
  const totalTaxAmount = checkout?.cost?.totalTaxAmount;

  const checkoutURL = checkout?.checkoutUrl || null;

  return (
    <div className="cart-footer">
      <hr />
      <div className="cart-checkout-recap">
        <div className="cart-checkout-recap__total">
          <p>{t("Subtotal")}:</p>
          <p>
            {subtotalAmount
              ? formatMoney(subtotalAmount.amount, subtotalAmount.currencyCode)
              : formatMoney("0.00", "CAD")}
          </p>
        </div>

        {/* Show tax if available */}
        {totalTaxAmount && (
          <div className="cart-checkout-recap__tax">
            <p>{t("Tax")}:</p>
            <p>{formatMoney(totalTaxAmount.amount, totalTaxAmount.currencyCode)}</p>
          </div>
        )}

        {/* Show total if different from subtotal */}
        {totalAmount && subtotalAmount && totalAmount.amount !== subtotalAmount.amount && (
          <div className="cart-checkout-recap__grand-total">
            <p>
              <strong>{t("Total")}:</strong>
            </p>
            <p>
              <strong>{formatMoney(totalAmount.amount, totalAmount.currencyCode)}</strong>
            </p>
          </div>
        )}
      </div>

      <>
        <hr />
        <a
          href={checkoutURL}
          className={`btn checkout-btn ${!checkoutURL ? "disabled" : ""}`}
          {...(!checkoutURL && {
            onClick: e => e.preventDefault(),
            "aria-disabled": "true",
          })}
        >
          {t("Checkout")}
        </a>
      </>
    </div>
  );
};

Footer.propTypes = {
  checkout: PropTypes.shape({
    checkoutUrl: PropTypes.string,
    cost: PropTypes.shape({
      subtotalAmount: PropTypes.shape({
        amount: PropTypes.string.isRequired,
        currencyCode: PropTypes.string.isRequired,
      }),
      totalAmount: PropTypes.shape({
        amount: PropTypes.string.isRequired,
        currencyCode: PropTypes.string.isRequired,
      }),
      totalTaxAmount: PropTypes.shape({
        amount: PropTypes.string.isRequired,
        currencyCode: PropTypes.string.isRequired,
      }),
    }),
    lines: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default Footer;
